import { format } from "date-fns";

import {
  USER_CLEANING_RECAP_PERIODS_ENDPOINT,
  USER_CLEANING_RECAP_YEARLY_ENDPOINT,
  USER_CLEANING_RECAP_MONTHLY_ENDPOINT,
  USER_CLEANING_RECAP_CUSTOM_ENDPOINT,
} from "@config/endpoints";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";
import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";
import { buildUrl } from "@services/BuildUrl";

import { genericPendingAction } from "@app/services/GenericPendingAction";
import { asyncActionCreator } from "@app/services/AsyncActionCreator";

const action = new ReduxActionNameCreator("recap");

const FETCH_RECAP = action.make("fetch recap");
const GENERATE_YEARLY_RECAP = action.make("generate yearly recap");
const GENERATE_MONTHLY_RECAP = action.make("generate monthly recap");
const GENERATE_CUSTOM_RECAP = action.make("generate custom recap");

const fetchRecap =
  () =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    dispatch(genericPendingAction(FETCH_RECAP));

    const action = await asyncActionCreator({
      action: FETCH_RECAP,
      method: ASYNC_ACTION_TYPES.GET,
      url: USER_CLEANING_RECAP_PERIODS_ENDPOINT,
    });

    return dispatch(action);
  };

const generateYearlyRecap =
  (year: string) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const action = await asyncActionCreator({
      action: GENERATE_YEARLY_RECAP,
      method: ASYNC_ACTION_TYPES.POST,
      url: buildUrl(USER_CLEANING_RECAP_YEARLY_ENDPOINT)
        .setPath("year", year)
        .done(),
    });

    return dispatch(action);
  };

const generateMonthlyRecap =
  (year: string, month: string) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const action = await asyncActionCreator({
      action: GENERATE_MONTHLY_RECAP,
      method: ASYNC_ACTION_TYPES.POST,
      url: buildUrl(USER_CLEANING_RECAP_MONTHLY_ENDPOINT)
        .setPath("year", year)
        .setPath("month", month)
        .done(),
    });

    return dispatch(action);
  };

const generateCustomRecap =
  (from: Date, to: Date) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const action = await asyncActionCreator({
      action: GENERATE_CUSTOM_RECAP,
      method: ASYNC_ACTION_TYPES.POST,
      url: buildUrl(USER_CLEANING_RECAP_CUSTOM_ENDPOINT)
        .setPath("from", format(from, "yyyy-MM-dd"))
        .setPath("to", format(to, "yyyy-MM-dd"))
        .done(),
    });

    return dispatch(action);
  };

export {
  FETCH_RECAP,
  fetchRecap,
  generateYearlyRecap,
  generateMonthlyRecap,
  generateCustomRecap,
};
